import moment from "moment"
import { OPENPROJECT_AMDTELECOM_BASEURL } from "../services/const"

export const getColorBasedOnDueDate = (dueDate:string):string => {
    if(dueDate){
      if(dueDate == moment().format('YYYY-MM-DD')){
        return 'orange'
      }
      if(new Date(dueDate) < new Date()){
        return 'red'
      }
    }
    return 'white'
}

export const generateOpenProjectTaskUrl = (taskId: string) => {
  const openProjectBaseUrl = OPENPROJECT_AMDTELECOM_BASEURL;
  if (openProjectBaseUrl) {
    return `${openProjectBaseUrl}/work_packages/${taskId}`;
  }
};

export const openProjectIssueStatuses:any = {elements:[]};